import React from 'react';
import Icon from '../Icon'

export default function MaleIcon({ title, fontSize }) {
    return (<Icon icon="businessman" title={title} style={{ color: "blue", fontSize: (fontSize)?fontSize:"16px", paddingRight: (title!== undefined)?"4px":"0px" }} className="male-icon"/>);
};